<!--
	作者：masonchen
	时间：2017-04-10
	描述：轨迹回放 -> 主面板 -> 预警现场 子组件
-->
<template>
	<li class="bgc_red" v-loading="loadingEx" element-loading-text="导出中">
		<dl>
			<dt>
                <p>
                  <input v-if="data.lockFlg !== 1" type="checkbox" v-model='isChecked'>
                  <span>
                  	<a v-show="data.lockFlg==1" class="ico_01a" @click="clickLock(data.lockFlg,data.id)" data-toggle="tracetip" data-placement="bottom" title="解锁"></a>
	              	<a v-show="data.lockFlg!=1" class="ico_01b" @click="clickLock(data.lockFlg,data.id)" data-toggle="tracetip" data-placement="bottom" title="锁定"></a>
                  <!--	<a @click="clickLock(data.lockFlg,data.id)" v-bind:class="[data.lockFlg === 1 ? 'ico_01a' : 'ico_01b']"></a>-->
                  </span>
                  <span class="sp_text">{{data.vehicleInfo.vehicleNum}}</span>
                  <i @click="getAlarmInfo" data-toggle="tracetip" data-placement="bottom" title="查看">
                  	<a class="ico_02"></a>
                  </i>
                  <i @click="exportAlarm" data-toggle="tracetip" data-placement="bottom" title="导出">
                  	<a class="ico_04" ><img src="../../../../assets/project/images/map/map_icon_56.png"/></a>
                  </i>
                </p>
                <p><em>{{data.vehicleInfo.plateNumber}}</em><b>{{data.vehicleInfo.ownerName}}</b></p>
			</dt>
			<dd><a class="noLink">报警现场</a><em>{{'VD'+data.deviceId}}</em><em>{{'AL'+data.almMsgId}}</em></dd>
		</dl>
		<div class="details">
			<p><span><em>{{time1}}</em><em>{{time2}}</em></span><span>{{data.almTypeStr}}</span></p>
		</div>
	</li>
</template>

<script>
	import {mapState} from 'vuex'
	import {Mixin} from './mixin'
	export default{
		mixins:[Mixin],
		data(){
			return {
				isChecked:this.data.isChecked,
				loadingEx:false,
				almCheckFlag:0 //是否点击了查看现场
			}
		},
		props: {
			data:{
				type: Object,
				default() {
					return{}
				}
			},
			checked:{
				type:Boolean
			}
		},
		computed: {
			...mapState({
				userId:state => state.user.userId
			}),
			time1(){
				if(this.data.gpsTime===null) return ''
				return this.data.gpsTime.split(' ')[0]
			},
			time2(){
				if(this.data.gpsTime===null) return ''
				return this.data.gpsTime.split(' ')[1]
			}
		},
		methods: {
			exportAlarm(){
				this.loadingEx = true
				this.$http.get(process.env.API_ROOT +'/trace/traces/alarms/export/' + this.data.id)
				.then((res)=>{
					let str = res.body.data
					var path = process.env.EXPORT_PATH;
					var api = process.env.API_ROOT;
					var fileName = path  + api + '/noauth/export?url=' + str + '&path=' + this.userId
	    			var elemIF = document.createElement("iframe");   
			      	elemIF.src = fileName;   
			        elemIF.style.display = "none";   
			        document.body.appendChild(elemIF); 
			        this.loadingEx = false
				},(res)=>{
					this.loadingEx = false
					const obj = {
						tipCnt:res.body.message,
						showBtn:false
					}
					this.$store.dispatch('showModal',obj);
				})
				.catch((res)=>{
					this.loadingEx = false
					const obj = {
						tipCnt:res.body.message,
						showBtn:false
					}
					this.$store.dispatch('showModal',obj);
				})
			},
			getAlarmInfo(){//获取预警信息
				const alarmObj = {
					id:this.data.id,
					showType:this.data.showType,
					vehiInfo:this.data.vehicleInfo,
					uni:new Date().getTime()
				}
				this.$store.dispatch('getAlarmInfo',alarmObj)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// VehicleItemAlarm.vue?11196a44